// extracted by mini-css-extract-plugin
module.exports = {"container":"e_c1","floatingBox":"e_d1","floatingAd":"e_e1"};